import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

export type Interval = { opens_at: string; closes_at: string };
export type WeeklySchedule = Record<string, Interval[]>;
export const weekDays = [
  "monday",
  "tuesday",
  "wednesday",
  "thursday",
  "friday",
  "saturday",
  "sunday",
];

export function WeeklyScheduleFields({
  schedule,
  onChange,
}: {
  schedule: WeeklySchedule;
  onChange: (value: WeeklySchedule) => void;
}) {
  const { t } = useTranslation();
  return (
    <div className="space-y-4">
      {weekDays.map((day) => {
        const intervals = schedule[day] || [];
        const update = (value: Interval[]) =>
          onChange({ ...schedule, [day]: value });
        return (
          <fieldset key={day} className="space-y-2 rounded-md border p-3">
            <legend className="px-1 text-sm font-medium">
              {t(`days.${day}`)}
            </legend>
            {intervals.length === 0 && (
              <p className="text-muted-foreground text-sm">
                {t("schedule_ui.closed")}
              </p>
            )}
            {intervals.map((interval, index) => (
              <div
                key={index}
                className="grid grid-cols-2 items-center gap-2 sm:grid-cols-[1fr_1fr_auto]"
              >
                {(["opens_at", "closes_at"] as const).map((field) => (
                  <Input
                    key={field}
                    type="time"
                    required
                    aria-label={`${t(`days.${day}`)} ${index + 1} ${t(`schedule_ui.${field}`)}`}
                    value={interval[field]}
                    onChange={(event) =>
                      update(
                        intervals.map((value, position) =>
                          position === index
                            ? { ...value, [field]: event.target.value }
                            : value,
                        ),
                      )
                    }
                  />
                ))}
                <Button
                  type="button"
                  variant="ghost"
                  className="col-span-2 w-fit sm:col-span-1"
                  onClick={() =>
                    update(
                      intervals.filter((_, position) => position !== index),
                    )
                  }
                >
                  {t("maps.interval_remove")}
                </Button>
              </div>
            ))}
            <Button
              type="button"
              variant="outline"
              size="sm"
              onClick={() =>
                update([
                  ...intervals,
                  { opens_at: "09:00", closes_at: "17:00" },
                ])
              }
            >
              {t("maps.interval_add")}
            </Button>
          </fieldset>
        );
      })}
    </div>
  );
}
